/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AppointmentTranscriptionMessage } from './AppointmentTranscriptionMessage';
import {
    AppointmentTranscriptionMessageFromJSON,
    AppointmentTranscriptionMessageFromJSONTyped,
    AppointmentTranscriptionMessageToJSON,
} from './AppointmentTranscriptionMessage';

/**
 * 
 * @export
 * @interface AppointmentTranscription
 */
export interface AppointmentTranscription {
    /**
     * 
     * @type {string}
     * @memberof AppointmentTranscription
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTranscription
     */
    tenant_id?: string;
    /**
     * 
     * @type {Array<AppointmentTranscriptionMessage>}
     * @memberof AppointmentTranscription
     */
    messages: Array<AppointmentTranscriptionMessage>;
}

/**
 * Check if a given object implements the AppointmentTranscription interface.
 */
export function instanceOfAppointmentTranscription(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "messages" in value;

    return isInstance;
}

export function AppointmentTranscriptionFromJSON(json: any): AppointmentTranscription {
    return AppointmentTranscriptionFromJSONTyped(json, false);
}

export function AppointmentTranscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentTranscription {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'messages': ((json['messages'] as Array<any>).map(AppointmentTranscriptionMessageFromJSON)),
    };
}

export function AppointmentTranscriptionToJSON(value?: AppointmentTranscription | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tenant_id': value.tenant_id,
        'messages': ((value.messages as Array<any>).map(AppointmentTranscriptionMessageToJSON)),
    };
}

